import { useContext, useCallback, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useUser } from "@auth";
import { Page } from ".";
import { Elements } from '@stripe/react-stripe-js';
import type { StripeElementsOptions } from "@stripe/stripe-js";
import { AuthContext } from "../../auth/auth-context";
import { useTranslation } from "react-i18next";

export const DashboardRouter = (): JSX.Element => {
  const partner = useUser();
  const {clientSecret, stripePromise} = useContext(AuthContext);
  const { i18n } = useTranslation();
  
  const isClientInitialized = clientSecret !== null && clientSecret !== undefined && clientSecret !== "" && stripePromise !== undefined;

  const stripeLocale = i18n.language === "fr" ? "fr" : "en";
  const stripeElementsKey = `${stripeLocale}-${clientSecret || "none"}`;

  const options: StripeElementsOptions = {
    clientSecret: clientSecret,
    loader: 'always',
    locale: stripeLocale,
  }

  return (
    <Routes>
      <Route
        path="/*"
        element={
          !partner?.didLogin || !partner?.organization /* || true */ ? (
            <Page variant="welcome" />
          ) : (
            !partner?.address ? (
              <Page variant="onboarding-address" />
            ) : (
              <Page variant="home" />
            )
          )
        }
      />
      <Route path="welcome" element={<Page variant="welcome" />} />
      <Route path="upload-logo" element={<Page variant="upload-logo" />} />
      <Route path="cashback-rewards" element={<Page variant="cashback-rewards" />} />
      <Route path="group-insurance" element={<Page variant="group-insurance" />} />
      <Route path="airdrop">
        <Route path="*" element={<Page variant="airdrop" />} />
        <Route path="complete" element={<Page variant="airdrop-complete" />} />
        <Route path="confirm" element={<Page variant="airdrop-confirm" />} />
        <Route path="history" element={<Page variant="airdrop-history" />} />
        <Route path="main" element={<Page variant="airdrop" />} />
        <Route path="select-members" element={<Page variant="select-members" />} />
        <Route path="select-offers" element={<Page variant="select-offers" />} />
        <Route path="select-amount" element={<Page variant="select-amount" />} />
      </Route>
      <Route path="celebrations">
        <Route path="main" element={<Page variant="celebrations-main" />} />
        <Route path="birthdays" element={<Page variant="celebrations-birthday" />} />
        <Route path="holidays" element={<Page variant="celebrations-holiday" />} />
        <Route path="seniority" element={<Page variant="celebrations-seniority" />} />
        <Route path="custom" element={<Page variant="celebrations-custom" />} />
      </Route>
      <Route path="lifestyle">
        <Route path="*" element={<Page variant="lifestyle-main" />} />
        <Route path="main" element={<Page variant="lifestyle-main" />} />
        <Route path="create-group" element={<Page variant="lifestyle-categories" />} />
        <Route path="rules" element={<Page variant="lifestyle-rules" />} />
        <Route path="confirm" element={<Page variant="lifestyle-confirm" />} />
        <Route path="complete" element={<Page variant="lifestyle-complete" />} />
        <Route path="manage-group" element={<Page variant="lifestyle-manage-group" />} />
        <Route path="transactions" element={<Page variant="lifestyle-transactions" />} />
      </Route>
      <Route path="onboarding-address" element={<Page variant="onboarding-address" />} />{/* PTODO: Change url to remove the "onboarding" term, not best practice */}
      <Route path="onboarding-add-card" element={
        !isClientInitialized ? 
          <Page variant="pendingApproval"/>
        : 
          <Elements key={`onboarding-${stripeElementsKey}`} stripe={stripePromise} options={options}>
            <Page variant="onboarding-add-card" />
          </Elements>
        } />
      <Route
        path="home"
        element={
          !partner?.didLogin ? (
            // Here when the partner has not been approved yet: Normally didLogin sets to true ONLY when user approved, to confirm
            /* !partner?.organization ? (
              <Page variant="welcome" />
            ) : ( */
              <Page variant="pendingApproval" />
            /* ) */
          ) : (
            <Page variant="home" />
          )
        }
      />
      <Route path="team" element={<Page variant="team" />} />
      <Route
        path="pendingApproval"
        element={<Page variant="pendingApproval" />}
      />
      <Route path="profile" element={<Page variant="profile" />} />
      <Route path="benefits" element={<Page variant="perks" />} />
      <Route path="billing" element={
        !isClientInitialized ? 
          <Page variant="pendingApproval"/>
        : 
          <Elements key={`billing-${stripeElementsKey}`} stripe={stripePromise} options={options}>
            <Page variant="billing" />
          </Elements>
        } />
    </Routes>
  );
};
